import { render, staticRenderFns } from "./statement-report.vue?vue&type=template&id=611a941e"
import script from "./statement-report.vue?vue&type=script&lang=js"
export * from "./statement-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports